import type { TaskStav } from './api';

/**
 * URL search params shared by the list (`/ukoly`) and detail
 * (`/ukoly/$id`) routes so the detail's master rail mirrors the cohort the
 * user was browsing (state filter + "moje" toggle + name search).
 */
export type UkolyStavFilter = TaskStav | 'otevrene' | 'vse';

export interface UkolySearch {
  mine?: boolean;
  stav?: UkolyStavFilter;
  search?: string;
}

const VALID_STAV = new Set<UkolyStavFilter>([
  'otevrene',
  'aktivni',
  'prijato',
  'splneny',
  'zruseny',
  'vse',
]);

export function parseUkolySearch(input: Record<string, unknown>): UkolySearch {
  const out: UkolySearch = {};
  // Tri-state: true / explicit false / absent. Absent means "use the default"
  // (Moje on) — so an explicit false must be preserved to turn it off.
  if (input.mine === true || input.mine === '1' || input.mine === 'true') out.mine = true;
  else if (input.mine === false || input.mine === '0' || input.mine === 'false') out.mine = false;
  if (typeof input.stav === 'string' && VALID_STAV.has(input.stav as UkolyStavFilter)) {
    out.stav = input.stav as UkolyStavFilter;
  }
  if (typeof input.search === 'string' && input.search.trim()) out.search = input.search.trim();
  return out;
}
